module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-21.f5013b01.png";